import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// const slides = [
//   { image: "/assets/img/main/pp1.png" },
//   { image: "/assets/img/main/pp2.png" },
//   { image: "/assets/img/main/pp3.png" },
// ];

const slides = [
  { image: "/assets/img/sagama01.jpeg" },
  { image: "/assets/img/sagama02.jpeg" },
  { image: "/assets/img/sagama03.jpeg" },
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  // Autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="th-hero-wrapper hero-11" id="hero">
      <style>{`
        .hero-slideshow {
          position: relative;
          width: 100%;
          height: 100vh;
          min-height: 600px;
          overflow: hidden;
        }
        .hero-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transition: opacity 1s ease-in-out;
        }
        .hero-slide.active {
          opacity: 1;
        }
        .hero-overlay {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0, 0, 0, 0.55); /* dark overlay for text readability */
        }
        .hero-content {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          height: 100%;
          padding: 0 15px;
        }
        .hero-style11 .hero-title {
          font-size: 3rem;
          font-weight: 700;
          line-height: 1.2;
          color: #fff;
          margin-bottom: 1.5rem;
          max-width: 700px;
        }
        .hero-style11 .hero-title span {
          color: #e86b24;
        }
        @media (max-width: 768px) {
          .hero-style11 .hero-title {
            font-size: 2rem;
          }
        }
        .hero-style11 .btn-group.style2 {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
        }
        .hero-style11 .btn-estates {
          background: linear-gradient(135deg, #e86b24, #d2551a);
          color: #fff;
          font-weight: 700;
          padding: 14px 30px;
          border-radius: 50px;
          font-size: 1rem;
          letter-spacing: 0.5px;
          border: none;
          box-shadow: 0 4px 14px rgba(232,107,36,0.4);
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          text-decoration: none;
        }
        .hero-style11 .btn-estates:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(232,107,36,0.55);
          background: linear-gradient(135deg, #d2551a, #b8430e);
        }
        .hero-style11 .btn-whatsapp {
          background: #25D366;
          color: #fff;
          font-weight: 700;
          padding: 14px 30px;
          border-radius: 50px;
          font-size: 1rem;
          letter-spacing: 0.5px;
          border: none;
          box-shadow: 0 4px 14px rgba(37,211,102,0.4);
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          text-decoration: none;
        }
        .hero-style11 .btn-whatsapp:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(37,211,102,0.55);
          background: #1da851;
        }
        .hero-style11 .btn-whatsapp i {
          margin-right: 8px;
          font-size: 1.2rem;
        }
        .hero-style11 .btn-estates i {
          margin-left: 8px;
        }
      `}</style>

      <div className="hero-slideshow">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === current ? "active" : ""}`}
            style={{ backgroundImage: `url('${slide.image}')` }}
          >
            <div className="hero-overlay" />
          </div>
        ))}
        <div className="container hero-content">
          <div className="hero-style11">
            <h1 className="hero-title">
              Build Your Legacy. <br />
              Own Your Future. <br />
              <span>Your Gateway to Premium Real Estate in Abuja.</span>
            </h1>
            <div className="btn-group style2">
              <Link to="/top-estates" className="btn-estates">
                View Available Estates{" "}
                <i className="fas fa-arrow-right ms-2"></i>
              </Link>
              <Link
  to="https://wa.me/23407055558942"
  className="btn-whatsapp"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-whatsapp"></i> Chat on WhatsApp
</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
